import { createSelector } from 'reselect';
import { GlobalState } from '@/redux/store';
import {
    HouseBillingAccountStatus,
    HouseBillingStatusSlice,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.types';

const sliceSelector = (state: GlobalState): HouseBillingStatusSlice => state.houseBillingStatus;
const idSelector = (_: GlobalState, houseId: number) => houseId;
const isLoadingSelector = createSelector([sliceSelector, idSelector], (slice, houseId) =>
    slice.loading.includes(houseId)
);

export const getIsSavingHouseBillingStatus = createSelector([sliceSelector], (slice) => slice.isSaving);

const getHouseBillingStatus = createSelector([sliceSelector, idSelector], (slice, houseId) => slice.byId[houseId]);

export const getHouseBillingStatusAccountStatus = createSelector(
    [getHouseBillingStatus],
    (houseBillingStatus) => houseBillingStatus?.accountStatus ?? HouseBillingAccountStatus.Unavailable
);

export const getHouseBillingStatusBalance = createSelector(
    [getHouseBillingStatus],
    (houseBillingStatus) => houseBillingStatus?.balance ?? 0
);

export const getHouseBillingStatusCurrency = createSelector(
    [getHouseBillingStatus],
    (houseBillingStatus) => houseBillingStatus?.currency ?? 'NOT SET'
);

export const getHouseBillingStatusHouseName = createSelector(
    [getHouseBillingStatus],
    (houseBillingStatus) => houseBillingStatus?.name ?? ''
);

export const shouldFetchHouseBillingStatus = createSelector(
    [getHouseBillingStatus, isLoadingSelector],
    (houseBillingStatus, isLoading) => !(Boolean(houseBillingStatus) || isLoading)
);
